import React from "react";
import { motion } from "framer-motion";
import WeatherfulBot from "../../assets/WeatherfulBot/Demo.png";
import OptionBrew from "../../assets/OptionBrew/Demo.png";
import TicTacToe from "../../assets/TicTacToe/Demo.png";
import Portfolio from "../../assets/Portfolio/Demo.png";
import Answerd from "../../assets/Answer-d/Demo.png";
import ChessEngine from "../../assets/ChessEngine/feature1.png";
import GroceryStore from "../../assets/GroceryStore/Demo.png";
import ComputerGraphics from "../../assets/ComputerGraphics/Demo.png";
import ClientRiskClassifier from "../../assets/ClientRiskClassifier/Demo.png";
import Topognn from "../../assets/Topognn/Demo.png";
import FiPortfolio from "../../assets/FiPortfolio/Demo.png";
import Taxloss from "../../assets/Taxloss/Demo.png";
import TaxlossInference from "../../assets/Taxloss/Inference.png";
import "./Projects.css";

// NOTE: Topognn / FiPortfolio / Taxloss / ClientRisk reuse the Portfolio
// image as a placeholder — drop a real screenshot into
// src/assets/<Project>/Demo.png and swap the import.
export const projectList = [
  {
    title: "topognn",
    built: "Apr 2026",
    tagline: "Topology-aware GNN that predicts NCCL collective performance.",
    description:
      "Heterogeneous GNN over GPU, NIC, and switch nodes (NVLink, PCIe, RoCE) that predicts latency and busbw for NCCL collectives. Used as a learned cost model to pick NCCL_ALGO and NCCL_PROTO at job-launch instead of runtime sweeps. C++/CUDA probes, PyTorch + PyG modeling.",
    tags: ["PyTorch", "PyG", "CUDA", "NCCL", "C++", "Python"],
    image: Topognn,
    demoLink: "#",
    githubLink: "https://github.com/eddayyy/topognn",
    featured: true,
  },
  {
    title: "Fixed Income Portfolio Construction",
    built: "Apr 2026",
    tagline: "Fixed-income analytics and a CVXPY portfolio optimizer.",
    description:
      "FastAPI backend implementing curve bootstrap, KRDs, duration and convexity, and scenario shocks, with a CVXPY QP optimizer over duration, sector, and rating bands. Vite + React + TypeScript SPA covering builder, scenario engine, and glossary. Terraform reference modules for AWS.",
    tags: ["FastAPI", "Python", "CVXPY", "TypeScript", "React", "Terraform"],
    image: FiPortfolio,
    demoLink: "#",
    githubLink: "https://github.com/eddayyy/fi-portfolio-construction",
  },
  {
    title: "Tax-Loss Rebalancing Engine",
    built: "Apr 2026",
    tagline: "Full local ML lifecycle for tax-aware portfolio rebalancing.",
    description:
      "End-to-end pipeline driven by a single CLI: synthetic data → ETL → feature parquet → KL/L1/Wasserstein drift + wash-sale-aware harvester → Optuna-tuned LightGBM (vs. logistic-regression baseline) → PPO/TD3 against a custom Gymnasium env → LSTM/TCN drawdown forecaster → MLflow registry → FastAPI /predict that auto-discovers the freshest model. Dockerized via compose (postgres + redis + mlflow + inference + trainer); 35 tests at 86% coverage.",
    tags: ["Python", "LightGBM", "stable-baselines3", "PyTorch", "MLflow", "FastAPI", "Docker"],
    image: Taxloss,
    secondaryImage: TaxlossInference,
    demoLink: "#",
    githubLink: "#",
  },
  {
    title: "Client Risk Classifier",
    built: "Aug 2025",
    tagline: "Logistic regression on bank customer data, dockerized.",
    description:
      "Multi-class supervised pipeline that classifies clients as Conservative, Moderate, or Aggressive from banking features. Preprocessing, evaluation plots (decision boundary, confusion matrix, ROC, PR), and a Docker build for reproducibility.",
    tags: ["Python", "scikit-learn", "Docker", "Pandas"],
    image: ClientRiskClassifier,
    demoLink: "#",
    githubLink: "https://github.com/eddayyy/client-risk-classifier",
  },
  {
    title: "Stock Market Broker App",
    built: "Feb 2024",
    tagline: "Trading dashboard on Alpaca's API.",
    description:
      "React frontend, Django REST backend, and a WebSocket pipeline streaming live quotes for sub-second chart updates.",
    tags: ["Python", "React", "Django", "WebSockets", "Alpaca API"],
    image: OptionBrew,
    demoLink: "#",
    githubLink: "#",
  },
  {
    title: "Weatherful Bot",
    built: "Oct 2023",
    tagline: "Scheduled weather updates posted to Twitter/X.",
    description:
      "Python bot triggered on a schedule by AWS Lambda + EventBridge. Pulls Weatherbit forecasts and posts them to Twitter/X.",
    tags: ["Python", "AWS Lambda", "EventBridge"],
    image: WeatherfulBot,
    demoLink: "https://twitter.com/WeatherfulBot",
    githubLink: "#",
  },
  {
    title: "Chess Engine",
    built: "Sep 2023",
    tagline: "Chess implemented from scratch in C++.",
    description:
      "Polymorphic piece hierarchy, encapsulated game state, and an SDL-rendered board. No engine library — move generation, validation, and turn logic are all hand-written.",
    tags: ["C++", "SDL", "OO Design"],
    image: ChessEngine,
    demoLink: "#",
    githubLink: "https://github.com/eddayyy/Chess-Engine-Src",
  },
  {
    title: "Computer Graphics",
    built: "Fall 2023",
    tagline: "Ray tracer, OpenGL scenes, and 3D math from scratch.",
    description:
      "Coursework-grade graphics primitives built without engine dependencies: a Python ray tracer rendering reflective spheres, an OpenGL C++ scene, and hand-rolled 3D matrix and quaternion libraries with templated vector / matrix types for transforms and rotations.",
    tags: ["C++", "Python", "OpenGL", "Ray Tracing", "Linear Algebra"],
    image: ComputerGraphics,
    demoLink: "#",
    githubLink: "https://github.com/eddayyy/ComputerGraphics",
  },
  {
    title: "Answer-D",
    built: "Spring 2023",
    tagline: "Q&A platform for one university domain.",
    description:
      "Q&A app restricted to verified CSUF accounts. Team-led group project run on weekly sprints with stand-ups and Jira; frontend built in vanilla JS, HTML, and CSS.",
    tags: ["JavaScript", "HTML", "CSS", "Agile"],
    image: Answerd,
    demoLink: "https://answer-362.github.io/Answer-d/",
    githubLink: "https://github.com/eddayyy/Answer-d",
  },
  {
    title: "AI Tic-Tac-Toe",
    built: "Dec 2023",
    tagline: "Tic-tac-toe with an unbeatable AI opponent.",
    description:
      "Two-player and AI variants in C++. The AI uses Alpha-Beta Pruning over a state-evaluation function to play optimally.",
    tags: ["C++", "Algorithms", "Game AI"],
    image: TicTacToe,
    demoLink: "#",
    githubLink: "https://github.com/eddayyy/TicTacToe",
  },
  {
    title: "Grocery Store System",
    built: "Mar 2023",
    tagline: "Inventory and checkout logic in modern C++.",
    description:
      "C++ implementation of a grocery store's logic system. Exercises OOP design, dynamic arrays, and singly/doubly linked list internals — all hand-rolled, no STL containers for the core data structures.",
    tags: ["C++", "OOP", "Data Structures"],
    image: GroceryStore,
    demoLink: "#",
    githubLink: "https://github.com/eddayyy/GroceryStore",
  },
  {
    title: "Portfolio Website",
    built: "2024 — ongoing",
    tagline: "This site.",
    description:
      "Editorial-financial portfolio in React + Tailwind, deployed on Netlify with Cloudflare DNS. Framer-motion choreography, scroll-spy nav, and a full dark mode.",
    tags: ["React", "Framer Motion", "Tailwind", "Netlify"],
    image: Portfolio,
    demoLink: "https://eduardonunez.dev",
    githubLink: "#",
  },
];

const ProjectCard = ({ project }) => {
  const featured = !!project.featured;

  return (
    <motion.article
      className={`proj-card ${featured ? "proj-card--featured" : ""}`}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.15 }}
      transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="proj-image-wrap">
        <img
          src={project.image}
          alt={`${project.title} preview`}
          className="proj-image"
        />
      </div>

      <div className="proj-body">
        <span className="proj-built">{project.built}</span>
        <h3 className="proj-title">{project.title}</h3>
        <p className="proj-tagline">{project.tagline}</p>
        <p className="proj-description">{project.description}</p>

        <p className="proj-built-with">
          <span className="proj-built-with-label">made with —</span>
          {project.tags.join(" · ")}
        </p>

        <div className="proj-links">
          {project.demoLink !== "#" && (
            <a
              href={project.demoLink}
              target="_blank"
              rel="noopener noreferrer"
              className="proj-link proj-link--primary"
            >
              demo <span className="proj-arrow">↗</span>
            </a>
          )}
          {project.githubLink !== "#" && (
            <a
              href={project.githubLink}
              target="_blank"
              rel="noopener noreferrer"
              className="proj-link"
            >
              source <span className="proj-arrow">↗</span>
            </a>
          )}
        </div>
      </div>
    </motion.article>
  );
};

const Projects = () => {
  const [latest, ...rest] = projectList;

  return (
    <section id="projects">
      <motion.div
        className="section-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.4 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="eyebrow">03 — Nights &amp; Weekends</span>
        <h2 className="display">
          Built for <em>curiosity.</em>
        </h2>
        <p className="proj-subhead">
          Personal builds. No deadlines, no stakeholders — just things I wanted
          to tinker with & figure out.
        </p>
      </motion.div>

      <div className="proj-list">
        <ProjectCard project={latest} />
        <div className="proj-grid">
          {rest.map((p) => (
            <ProjectCard key={p.title} project={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
